module.exports = __webpack_public_path__ + "img/arrow_down_graph.7f8caf62.svg";